import {LOCALE_ID, NgModule, provideZonelessChangeDetection} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {NgxCaptchaModule} from 'ngx-captcha';
import {
  ApiBaseToken,
  ApiBrandToken,
  AuthorizationBaseService,
  AuthorizationService,
  DISPLAY_DATE_FORMAT,
  DisplayDateFormatToken,
  I18nModule,
  StoredFormsModule,
  commonInterceptors,
  TranslationsBrandToken,
  EnvironmentToken
} from '@twino/core-lib';
import {CommonModule, registerLocaleData} from '@angular/common';
import {RoutesModule} from './routes/routes.module';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import { CommonComponentsModule, NetcardSharedModule, TwinoCoreModule } from '../../../../libs/commons';
import {
  HalvoApplicationLayoutComponent
} from "./components/halvo-application-layout/halvo-application-layout.component";
import {ModalNotificationsModule} from "../../../../libs/commons/modal-notifications/modal-notifications.module";
import {environment} from "../environments/environment";
import {COMMONS_LIB_CONFIG, CommonsLibConfig} from "../../../../libs/commons/commons-lib-config";

import localePl from '@angular/common/locales/pl';

registerLocaleData(localePl);

export function commonsConfigFactory(): CommonsLibConfig {
  return {
    kontomatikClientId: environment.kontomatikClientId,
  };
}
@NgModule({
  declarations: [AppComponent, HalvoApplicationLayoutComponent],
  imports: [
    CommonModule,
    BrowserModule,
    TwinoCoreModule,
    CommonComponentsModule,
    NetcardSharedModule.forRoot({
      provide: COMMONS_LIB_CONFIG,
      useFactory: commonsConfigFactory,
    }),
    AngularSvgIconModule.forRoot(),
    NgxCaptchaModule,
    StoredFormsModule,
    I18nModule,
    RoutesModule,
    ModalNotificationsModule
  ],
  providers: [
    ...commonInterceptors,
    {provide: ApiBaseToken, useValue: `/ws/api/`},
    {provide: ApiBrandToken, useValue: `HALVO`},
    {provide: TranslationsBrandToken, useValue: `halvo`},
    {provide: EnvironmentToken, useValue: environment},
    {provide: DisplayDateFormatToken, useValue: DISPLAY_DATE_FORMAT},
    {provide: AuthorizationBaseService, useExisting: AuthorizationService},
    { provide: LOCALE_ID, useValue: 'pl' },
    provideZonelessChangeDetection(),
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
